import { getAmountOfTokenInPool } from "./PriceUtils";
import icons from "./tokenIcons";
import BigNumber from "bignumber.js";
const { getTotalSupply } = require("./ERC20Utils");
const { rpcUrl } = require("./configs");
const { erc20ABI } = require("./abi/ERC20Abi");
const { FarmAbi } = require("./abi/FarmAbi");

const Web3 = require("web3");
const web3 = new Web3(rpcUrl);
const { fromWei } = web3.utils;

export const kovanFarms = {
  address: "0x50EC06781806Ea8924E4feBA21D78Fd5b3A5BfA0",
  abi: FarmAbi,
  farms: [
    {
      name: "CORSAC",
      stakedToken: {
        address: "0x386082a15877D8ebF3157771eb8c0c731FfD1eB4",
        symbol: "CORSAC",
        name: "Corsac",
        icon: icons.corsac,
      },
      lpToken: "0x386082a15877D8ebF3157771eb8c0c731FfD1eB4",
      weightedToken: "CORSAC",
      weightedTokenAddress: "0x386082a15877D8ebF3157771eb8c0c731FfD1eB4",
      composition: "CORSAC (100%)",
      pid: 0,
      percentage: 100,
      tags: "CORSAC",
      buyLink:
        "https://pancakeswap.finance/swap?outputCurrency=0x25c39b6c5ec8a9d81826f9f0e6448ceaea1570b4",
      active: true,
      balancerId: "",
    },
    {
      name: "CORSAC-BNB LP",
      stakedToken: {
        address: "0x0ADdF6220467Cf01f628273971C485037c2135c4",
        symbol: "CORSAC-BNB LP",
        name: "CORSAC-BNB LP",
        icon: icons.corsacBNBLPIcon,
      },
      lpToken: "0x0ADdF6220467Cf01f628273971C485037c2135c4",
      weightedToken: "CORSAC",
      weightedTokenAddress: "0x386082a15877D8ebF3157771eb8c0c731FfD1eB4",
      composition: "CORSAC (50%), BNB (50%)",
      pid: 1,
      percentage: 50,
      tags: "CORSAC,BNB,LP",
      buyLink:
        "https://pancakeswap.finance/add/BNB/0x25c39B6c5Ec8a9d81826F9F0E6448ceAEA1570b4",
      active: true,
      balancerId: "",
      decimals: 9,
    },
    {
      name: "CORSAC 2",
      stakedToken: {
        address: "0x386082a15877D8ebF3157771eb8c0c731FfD1eB4",
        symbol: "Corsac V2 Token",
        name: "Corsac",
        icon: icons.corsac,
      },
      lpToken: "0x386082a15877D8ebF3157771eb8c0c731FfD1eB4",
      weightedToken: "CORSAC",
      weightedTokenAddress: "0x386082a15877D8ebF3157771eb8c0c731FfD1eB4",
      composition: "CORSAC (100%)",
      pid: 2,
      percentage: 100,
      tags: "CORSAC",
      buyLink:
        "https://pancakeswap.finance/swap?outputCurrency=0x25c39b6c5ec8a9d81826f9f0e6448ceaea1570b4",
      active: true,
      balancerId: "",
      decimals: 18,
    },
  ],
};

export const mainNetFarms = {
  // TODO put bsc farms here once deployed
  address: "0x7dEea51078a191382ef52947B4819573B5681385",
  abi: FarmAbi,
  farms: [
    {
      name: "CORSAC",
      stakedToken: {
        address: "0x25c39B6c5Ec8a9d81826F9F0E6448ceAEA1570b4",
        symbol: "CORSAC",
        name: "Corsac",
        icon: icons.corsac,
        decimals: 9,
      },
      lpToken: "0x25c39B6c5Ec8a9d81826F9F0E6448ceAEA1570b4",
      weightedToken: "CORSAC",
      weightedTokenAddress: "0x25c39B6c5Ec8a9d81826F9F0E6448ceAEA1570b4",
      composition: "CORSAC (100%)",
      pid: 0,
      percentage: 100,
      tags: "CORSAC",
      buyLink:
        "https://pancakeswap.finance/swap?outputCurrency=0x25c39b6c5ec8a9d81826f9f0e6448ceaea1570b4",
      active: true,
      balancerId: "",
      decimals: 9,
    },
    {
      name: "CORSAC-BNB LP",
      stakedToken: {
        address: "0x4D28211965d6f4c8BAD68c0670539EABCF4569c2",
        symbol: "CORSAC-BNB LP",
        name: "CORSAC-BNB LP",
        icon: icons.corsacBNBLPIcon,
        decimals: 18,
      },
      lpToken: "0x4D28211965d6f4c8BAD68c0670539EABCF4569c2",
      weightedToken: "CORSAC",
      weightedTokenAddress: "0x25c39B6c5Ec8a9d81826F9F0E6448ceAEA1570b4",
      composition: "CORSAC (50%), BNB (50%)",
      pid: 1,
      percentage: 50,
      tags: "CORSAC,BNB,LP",
      buyLink:
        "https://pancakeswap.finance/add/BNB/0x25c39B6c5Ec8a9d81826F9F0E6448ceAEA1570b4",
      active: true,
      balancerId: "",
      decimals: 18,
    },
  ],
};

/**
 *
 * @param pid
 * @param pool
 * @param totalRewardsPerWeek
 * @param corsacPrice
 * @param rewardTokenPrice
 * @param decimals
 * @returns {Promise<number>}
 */
export const getAPYForPID = async (
  pid,
  pool,
  totalRewardsPerWeek,
  { getLPPricesPrice },
  rewardTokenPrice,
  decimals,
  lpDecimals
) => {
  const lpPrices = await getLPPricesPrice();
  const priceOfRewardsPerWeek = new BigNumber(
    totalRewardsPerWeek * 10 ** (lpDecimals ? -lpDecimals : -9)
  ).times(new BigNumber(rewardTokenPrice));
  const pricePerLP = lpPrices[pid];

  if (pool.stakedAmount === "0") {
    pool.stakedAmount = "1";
  }
  // roughly 53 weeks a year
  return (
    ((Number(priceOfRewardsPerWeek) * 52.1775) /
      Number((pricePerLP * pool.stakedAmount) / 10 ** decimals)) *
    100
  );
};

/**
 * @param pid
 * @param pool
 * @param priceOfWeightedToken
 * @param farmConfig
 * @param ethereum
 * @returns {Promise<number|*>}
 */
export const getLPPrice = async (
  pid,
  pool,
  priceOfWeightedToken,
  farmConfig,
  ethereum
) => {
  const weight = farmConfig.farms[pid].percentage;
  if (weight === 100) {
    return priceOfWeightedToken;
  }
  const lpContract = new web3.eth.Contract(erc20ABI, pool.lpToken);
  const totalPoolSupply = new BigNumber(fromWei(await getTotalSupply(lpContract)));

  const amountofWeightedToken = new BigNumber(
    await getAmountOfTokenInPool({
      LpToken: pool.lpToken,
      ethereum,
      tokenAddress: farmConfig.farms[pid].weightedTokenAddress,
    })
  );

  const totalWeightedTpokenValue = amountofWeightedToken
    .div(10 ** 9) // TODO
    .times(priceOfWeightedToken);

  const priceOfLP = totalWeightedTpokenValue
    .times(100)
    .div(weight)
    .div(totalPoolSupply);

  return Number(priceOfLP);
};
